import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { selectOrganizations } from 'src/app/accounts/store/accounts.feature';
import { selectAreOrganizationsNotEmpty } from 'src/app/accounts/store/accounts.selectors';
import { ICreateAccount } from 'src/app/shared/account/create-account.helper';
import { WhiteLabelService } from 'src/app/white-label/white-label.service';
import { BaseStepComponent } from '../base-step.component';
import { OrganizationAclService } from 'src/app/organization/organization-acl.service';
import { takeUntil } from 'rxjs/operators';
import { Organization } from 'src/app/organization/shared/organization.types';
import { ICON_QUESTION_MARK } from 'src/app/shared/named-icons.config';

@Component({
  selector: 'app-step1',
  templateUrl: './step1.component.html',
})
export class Step1Component extends BaseStepComponent implements OnInit, OnDestroy {
  @Input()
  public defaultValues: Partial<ICreateAccount>;

  @Output()
  public nextStep: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  public updateParentModel = new EventEmitter<{
    part: Partial<ICreateAccount>,
    isFormValid: boolean
  }>();

  public form: FormGroup;

  public readonly ICON_QUESTION_MARK = ICON_QUESTION_MARK;
  public readonly organizationsList$: Observable<Organization.Organization[]>;
  public readonly areOrganizationsAvailable$: Observable<boolean>;
  public readonly whiteLabelService: WhiteLabelService;
  public readonly organizationAclService: OrganizationAclService;

  private readonly destroyed$: Subject<void> = new Subject();
  private readonly fb: FormBuilder;
  private readonly store: Store;

  constructor() {
    super()
    this.whiteLabelService = inject(WhiteLabelService);
    this.fb = inject(FormBuilder);
    this.organizationAclService = inject(OrganizationAclService);
    this.store = inject(Store);

    this.organizationsList$ = this.store.select(selectOrganizations);
    this.areOrganizationsAvailable$ = this.store.select(selectAreOrganizationsNotEmpty);
  }

  public ngOnInit(): void {
    this.initForm();
  }

  public initForm(): void {
    this.form = this.fb.group({
      accountType: [this.defaultValues.accountType, [Validators.required]],
      organizationId: [this.defaultValues.organizationId || '', []],
    });

    this.form.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe(val => {
        this.updateParentModel.emit({
          part: val,
          isFormValid: true
        });
      });
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
